/* eslint-disable max-len */

/**
 * switch position of w_ or h_ to avoid MCHGB-7437
 * @customParams {string} cloudinary image params
 */
var swapParams = function swapParams(customParams) {
  var newParams = customParams.split(',');
  var wIndex = null;
  var hIndex = null;
  newParams.forEach(function (value, index) {
    if (value.includes('w_')) {
      wIndex = index;
    }

    if (value.includes('h_')) {
      hIndex = index;
    }
  });

  if (wIndex !== null && !hIndex) {
    var itemToPush = newParams[wIndex];
    newParams.splice(wIndex, 1);
    newParams.push(itemToPush);
    newParams.join();
  }

  if (!wIndex && hIndex !== null) {
    var _itemToPush = newParams[hIndex];
    newParams.splice(hIndex, 1);
    newParams.push(_itemToPush);
    newParams.join();
  }

  return newParams;
};
/**
 * Gets the upload url and applies the transformation.
 * Used to replace fetch url which creates a new transformation and duplicate images
 * @originalUrl {string} cloudinary uploaded file
 * @params {string} cloudinary transformation settings
 */


export var uploadTransformationUrl = function uploadTransformationUrl(originalUrl, params, options) {
  var imgParams = params;
  var imgUrl = originalUrl;

  if (imgParams) {
    // force conversation from png to jpeg in case the png doesnt have transparency
    // https://cloudinary.com/documentation/image_optimization#how_to_optimize_image_format
    // if (!imgParams.includes('lossy')) {
    //   if (imgParams.includes('f_auto')) {
    //     imgParams = `${imgParams},fl_lossy`
    //   }
    //   if (!imgParams.includes('f_auto')) {
    //     imgParams = `${imgParams},f_auto,fl_lossy`
    //   }
    // }
    // switch position of w_ or h_ to avoid MCHGB-7437
    imgParams = swapParams(imgParams);
  }

  var applyExternalTransform = function applyExternalTransform(url) {
    // The caller of this function can pass an options object with a transformUrl function which will be
    // applied to the resulting URL
    if (options && options.transformUrl) {
      return options.transformUrl(url);
    }

    return url;
  }; // handle Cloudinary or Cloudfront image urls


  if (imgUrl && imgParams) {
    // fallback to use https always
    imgUrl = imgUrl.replace('http:', 'https:');

    if (imgUrl.includes('cloudinary') && !imgUrl.includes('cloudfront')) {
      /*
      Converts https://res.cloudinary.com/dqzqcuqf9/image/fetch/q_auto,w_278,dpr_1.0,f_auto/http://res.cloudinary.com/dqzqcuqf9/image/upload/v1591240779/mfp-fe-artworks/zpdg023fvfuqvq3brsij.png
      Into https://res.cloudinary.com/dqzqcuqf9/image/upload/q_auto,w_278,dpr_1.0,f_auto/v1591240779/mfp-fe-artworks/zpdg023fvfuqvq3brsij.png
      */
      if (!imgUrl.includes('upload/')) {
        return applyExternalTransform(imgUrl.replace('upload/', "upload/".concat(imgParams, "/")));
      }

      if (imgUrl.includes('mfp-fe-artworks')) {
        var url = imgUrl.toString().split('/');
        url.splice(6, 0, imgParams);
        url = url.join('/');
        return applyExternalTransform(url);
      }

      if (imgUrl.includes('mfp-fe-profile-image') || imgUrl.includes('mfp-onlineshow-image')) {
        var _url = imgUrl.toString().split('/');

        _url[6] = "".concat(_url[6], "/").concat(imgParams);
        _url = _url.join('/');
        return applyExternalTransform(_url);
      }

      if (imgUrl.includes('db-artworks') || imgUrl.includes('web-images')) {
        var _url2 = imgUrl.toString().split('/');

        _url2[5] = "".concat(_url2[5], "/").concat(imgParams);
        _url2 = _url2.join('/');
        return applyExternalTransform(_url2);
      }
    }
    /* https://res.cloudinary.com/dqzqcuqf9/image/fetch/ar_16:10,q_auto,w_580,dpr_1,c_fill,f_auto/https://d2u3kfwd92fzu7.cloudfront.net/gallery/Acquavella gallery photo-1.jpg */


    if (!imgUrl.includes('cloudinary') && imgUrl.includes('cloudfront')) {
      return applyExternalTransform("https://res.cloudinary.com/dqzqcuqf9/image/fetch/".concat(imgParams, "/").concat(imgUrl));
    }
  }

  return applyExternalTransform(imgUrl);
};
/**
 * Sends a tag to cloudinary with the name of the website plus environment
 * e.g. artbasel-test, artbasel-integration, artbasel-stage or artbasel-prod
 * @domain {string} environment host and domain
 * @theme {string} artbasel or grandbasel
 */

export var cloudinaryEnvTag = function cloudinaryEnvTag(domain, theme) {
  var tag = null;
  var host = domain;

  if (!host && typeof window !== 'undefined') {
    host = window.location.host; // eslint-disable-line prefer-destructuring
  }

  if (host.includes('localhost') || host.includes('test')) {
    tag = 'test';
  } else if (host.includes('integration')) {
    tag = 'integration';
  } else if (host.includes('stage')) {
    tag = 'stage';
  } else if (host.includes("www.".concat(theme)) || host.includes("https://".concat(theme, ".com"))) {
    tag = 'prod';
  }

  return tag ? "".concat(theme, "-").concat(tag) : null;
};
export default {};